import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useStyles, View} from "shared/base"
import {Pressable, StyleSheet} from "react-native"
import Card from "components/chalky-layout/card"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import PageContentsPresentation from "components/page-contents/presentation"
import React from "react"

const styles = StyleSheet.create({
  cardHeader: {
    marginBottom: 15
  },
  cardHeaderSmDown: {
    flexDirection: "row",
    alignItems: "center"
  },

  cardHeaderText: {
    fontSize: 24,
    fontWeight: "bold"
  },
  cardHeaderTextSmDown: {
    marginLeft: 4
  },
  cardHeaderTextMdUp: {
    marginTop: 15
  },

  activeCheckIcon: {color: "#5253ff"},

  activeCheckContainer: {
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    zIndex: 998,
    right: 24,
    bottom: 24,
    width: 24,
    height: 24,
    backgroundColor: "#fff",
    borderRadius: "50%"
  },
  activeCheckContainerMdUp: {
    width: 40,
    height: 40
  },

  iconContainer: {},
  iconContainerSmDown: {
    marginRight: 8
  },

  pressable: {
    position: "relative"
  }
})

/**
 * @typedef {object} RoutesUserCreateUserRoleCardProps
 * @property {unknown} active
 * @property {unknown} header
 * @property {unknown} icon
 * @property {string} iconVersion
 * @property {unknown} identifier
 * @property {unknown} liquidVariables
 * @property {unknown} onCardPress
 */

/** @typedef {object} RoutesUserCreateUserRoleCardState */

/**
 * @extends {ShapeComponent<RoutesUserCreateUserRoleCardProps, RoutesUserCreateUserRoleCardState>}
 */
class RoutesUserCreateUserRoleCard extends ShapeComponent {
  static defaultProps = {
    icon: null,
    iconVersion: "FontAwesome",
    liquidVariables: undefined
  }

  static propTypes = propTypesExact({
    active: PropTypes.bool.isRequired,
    header: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconVersion: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
    liquidVariables: PropTypes.object,
    onCardPress: PropTypes.func.isRequired
  })

  render() {
    const {active, header, icon, iconVersion, identifier, liquidVariables} = this.p
    const cardHeaderStyle = useStyles(styles, ["cardHeader"])
    const cardHeaderTextStyle = useStyles(styles, ["cardHeaderText"])
    const activeCheckContainerStyle = useStyles(styles, ["activeCheckContainer"])
    const iconContainerStyle = useStyles(styles, "iconContainer")
    const testID = `create-user-role-card-${identifier}`

    return (
      <Pressable
        dataSet={this.pressableDataSet ||= {component: "routes/user/create-user/role-card", identifier}}
        onPress={this.tt.onCardPress}
        style={styles.pressable}
        testID={testID}
      >
        <Card active={active} style={this.cardStyle ||= {minHeight: 350}} testID={`${testID}-card`}>
          <View style={this.cardInnerCenterViewStyle ||= {justifyContent: "center", height: "100%"}} testID={`${testID}-inner`}>
            <View testID={`${testID}-content`}>
              <View style={cardHeaderStyle} testID={`${testID}-header`}>
                {icon &&
                  <View style={iconContainerStyle} testID={`${testID}-icon-container`}>
                    <Icon name={icon} size={32} version={iconVersion} />
                  </View>
                }
                <Text style={cardHeaderTextStyle} testID={`${testID}-header-text`}>
                  {header}
                </Text>
              </View>
              <PageContentsPresentation
                identifier={`routes/user/create-user/role-card/description/${identifier}-description`}
                liquidVariables={liquidVariables}
              />
            </View>
          </View>
        </Card>
        {active &&
          <View style={activeCheckContainerStyle} testID={`${testID}-active-check`}>
            <Icon name="check" style={styles.activeCheckIcon} />
          </View>
        }
      </Pressable>
    )
  }

  onCardPress = () => this.p.onCardPress({identifier: this.p.identifier})
}

export default memo(shapeComponent(RoutesUserCreateUserRoleCard))
